export const SmallCheckIcon = () => (
    <svg width="10" height="8" viewBox="0 0 10 8" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M1 4.29371L4.15519 6.75L8.894 1.25"
            stroke="#333333"
            strokeWidth="1.5"
            strokeLinejoin="round"
        />
    </svg>
);
